import loadPolyfills from "dynamic-polyfill/src";
import polyfills from '../../polyfills.mjs';
import {trigger} from './lib/events';

Promise.resolve()
    .then(() => loadPolyfills({
        polyfills: polyfills,
        rum: true,
    }))
    .then(() => trigger.call(document, 'ready'))
    .catch(console.warn);
